module.exports = __webpack_public_path__ + "static/media/zippyclip-2.5aa30c0e.jpg";